import { Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import lodash from 'lodash';

import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { loadDocumentPermission } from 'indexDocuments/actions';
import LoadingComponent from 'common/permissions/components/LoadingComponent';

const ALLOWED_INDEXING_TYPES = ['initialIndex', 'index', 'reindex'];

class DocumentPermission extends Component {
    constructor(...args) {
        super(...args);
        this.state = {showComponent: false};
    }

    componentDidMount() {
        const { documentId, loadDocumentPermission } = this.props;
        if (!this.hasAllowedIndexType()) {
            this.handleInvalid();
        } else {
            loadDocumentPermission(documentId);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            documentId,
            documentPermission
        } = this.props;
        if (prevProps.documentId !== documentId) {
            this.hideComponent();
            loadDocumentPermission(documentId);
            return;
        }
        if (documentPermission !== prevProps.documentPermission) {
            this.actOnReceivedPermissions();
        }
    }

    render() {
        const {
            documentId,
            binderId,
            indexingType,
            documentPermission,
            setSidebarCollapsed,
            initialDocumentTypeId,
            successfulSaveRedirect,
        } = this.props;
        const { showComponent } = this.state;
        if (!documentPermission || !showComponent) {
            return <LoadingComponent />;
        }

        return cloneElement(this.props.children, {
            documentId,
            binderId,
            indexingType,
            documentPermission,
            setSidebarCollapsed,
            initialDocumentTypeId,
            successfulSaveRedirect,
        });
    }

    actOnReceivedPermissions() {
        const {
            documentPermission,
            indexingType
        } = this.props;
        if (!documentPermission) {
            return;
        }

        if (indexingType === 'initialIndex') {
            this.handleInitialIndex();
        } else if (indexingType === 'index') {
            this.handleIndex();
        } else if (indexingType === 'reindex') {
            this.handleReindex();
        } else {
            this.handleInvalid();
        }
    }

    hasAllowedIndexType() {
        const { indexingType } = this.props;
        return ALLOWED_INDEXING_TYPES.includes(indexingType);
    }

    handleInitialIndex() {
        const {
            documentPermission,
            binderId: urlBinderId,
        } = this.props;
        const {
            binderId,
            isIndexed,
            canInitialIndex,
            canManageIntegration
        } = documentPermission;
        if (isIndexed) {
            this.navigateBack('This document has already been indexed.');
        } else if (binderId !== urlBinderId) {
            this.navigateBack('The document cannot be accessed from this binder.');
        } else if (canManageIntegration || canInitialIndex) {
            this.showComponent();
        } else {
            this.navigateBack();
        }
    }

    handleIndex() {
        const {
            documentPermission
        } = this.props;
        const {
            isIndexed,
            canIndex,
            canManageIntegration
        } = documentPermission;
        if (canManageIntegration || isIndexed || canIndex) {
            this.showComponent();
        } else {
            this.navigateBack();
        }
    }

    handleReindex() {
        const {
            documentPermission
        } = this.props;
        const {
            isIndexed,
            canReindex,
            canManageIntegration
        } = documentPermission;
        if (canManageIntegration || isIndexed || canReindex) {
            this.showComponent();
        } else {
            this.navigateBack();
        }
    }

    handleInvalid() {
        this.navigateBack('The page you have attempted to visit is invalid.');
    }

    showComponent() {
        this.setState({showComponent: true});
    }

    hideComponent() {
        this.setState({showComponent: false});
    }

    navigateBack(message = 'You do not have permission to index this document at this stage.') {
        const { addApplicationMessage, goBack } = this.props;
        addApplicationMessage('error', message);
        goBack();
    }
}

export default connect((state, props) => {
    const documentId = props.documentId || lodash.get(props, 'params.documentId');
    const indexingType = props.indexingType || lodash.get(props, 'params.indexingType');
    const documentPermission = lodash.get(state, 'indexDocument.documentPermission');
    const initialDocumentTypeId = lodash.get(props, 'location.query.dt');
    const successfulSaveRedirect = lodash.get(props, 'location.query.rd');

    let binderId = props.binderId || lodash.get(props, 'params.id');

    if (props.isFromStudy) {
        binderId = props.study.binderId;
    }

    return {
        documentId,
        binderId,
        indexingType,
        documentPermission,
        initialDocumentTypeId,
        successfulSaveRedirect,
    };
}, {
    loadDocumentPermission,
    addApplicationMessage,
    goBack
})(DocumentPermission);